import { Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  TXTWCL_GET_READY_FOR_THE_GAME_CHANGER_ELL,
  TXTWCL_WEXRE_BUSY_MAKING_YOU_A_FASTER_ELL
} from './Migration.messages.json';
import styles from './Migration.scss';
import Logo from './assets/logo-pokerstars-sports.svg';

export const Migration: React.FC = () => (
  <div className={styles.banner}>
    <MigrationText />
  </div>
);

export const MigrationText: React.FC = () => (
  <div className={styles.messageContainer}>
    <h1 className={styles.title}>
      <Translation {...TXTWCL_GET_READY_FOR_THE_GAME_CHANGER_ELL} />
    </h1>
    <h2 className={styles.subTitle}>
      <Translation {...TXTWCL_WEXRE_BUSY_MAKING_YOU_A_FASTER_ELL} />
    </h2>
    <Logo className={styles.logo} />
  </div>
);

export default Migration;
